import { useState } from 'react'
import { X } from 'lucide-react'
import Button from '../Button'
import Input from '../Input'

function extractYouTubeID(url) {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\s]+)/,
    /youtube\.com\/embed\/([^&\s]+)/,
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match) return match[1]
  }

  return url
}

export default function YouTubeInsertDialog({ onInsert, onClose }) {
  const [url, setUrl] = useState('')
  const [error, setError] = useState(null)

  const handleInsert = () => {
    if (!url.trim()) {
      setError('Please enter a YouTube URL')
      return
    }

    const videoID = extractYouTubeID(url)

    if (!videoID || videoID === url) {
      setError('Invalid YouTube URL. Please enter a valid YouTube video URL.')
      return
    }

    onInsert(videoID)
    onClose()
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleInsert()
    }
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="text-lg font-semibold">Insert YouTube Video</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              YouTube URL
            </label>
            <Input
              value={url}
              onChange={(e) => {
                setUrl(e.target.value)
                setError(null)
              }}
              onKeyPress={handleKeyPress}
              placeholder="https://www.youtube.com/watch?v=..."
              autoFocus
            />
          </div>

          {error && (
            <div className="text-sm text-red-600 bg-red-50 p-2 rounded">
              {error}
            </div>
          )}

          <div className="text-xs text-gray-500">
            Supported formats:
            <ul className="list-disc list-inside mt-1">
              <li>https://www.youtube.com/watch?v=VIDEO_ID</li>
              <li>https://youtu.be/VIDEO_ID</li>
              <li>https://www.youtube.com/embed/VIDEO_ID</li>
            </ul>
          </div>
        </div>

        <div className="flex justify-end gap-2 p-4 border-t">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleInsert} disabled={!url.trim()}>
            Insert
          </Button>
        </div>
      </div>
    </div>
  )
}
